import { FC, ReactElement } from 'react'

const PreviewContainer: FC<{ children: ReactElement }> = ({ children }) => {
  return (
    <section className='w-full bg-jaa-shades-white rounded-lg shadow-[0px_1px_2px_0px_#1018280D] flex flex-col items-start h-[461px] lg:h-[700px]  '>
      {children}
    </section>
  )
}

export default PreviewContainer
